import Domains from '@lcsc-ui/utils/domains';
import { Image } from 'antd';

import InfoPageRight from '@/features/infoPageRight';
import ShareComponent from '@/features/shareComponent';
const InfoDetail = ({ infoDetail, pathName }) => {
  const information = infoDetail?.information || '';
  const keyWordHref = (value) => {
    location.href = `/${pathName}/list.html?keyword=${encodeURIComponent(encodeURIComponent(value))}`;
  };
  const searchCb = (searchKeyword) => {
    keyWordHref(searchKeyword);
  };
  return (
    <>
      <div className="w-[1200px] m-[10px_auto_14px]">
        {/* 左边 */}
        <section className="w-[71.5%] float-left min-h-[90px] mr-[1%] pb-[10px] bg-[#fff] rounded-[10px]">
          <div>
            {information ? (
              <div className="w-full m-[10px_auto_14px] p-[10px_20px] bg-white">
                <div className="m-[15px_20px_0_20px] pb-[10px] border-b border-solid border-[#f0f0f0] text-center">
                  <h1 className="text-[20px] leading-[30px] text-[#333333] pt-[15px] font-bold">{information.title}</h1>
                  <p className="text-[12px] mt-[15px] text-[#999]">
                    {information.shelfBeginTime && information.shelfBeginTime !== '' ? (
                      <span className="mr-[20px]">{information.shelfBeginTime}</span>
                    ) : (
                      <span className="mr-[20px]">{information.publishTime}</span>
                    )}
                    <span className="mr-[20px]">阅读量：{information.readCount}</span>
                    {information.source && information.source !== '' ? (
                      <span className="mr-[20px]">来源：{information.source}</span>
                    ) : null}
                  </p>
                </div>
                <div
                  className="richtext-content mt-[15px] mx-[20px] [&_img]:max-w-[96%] [&_img]:mx-auto"
                  dangerouslySetInnerHTML={{ __html: information.content }}
                />
                <div className="m-[25px_0_0]">
                  <div className="text-[12px]">
                    <div className="flex items-center">
                      {information.tagRelaList && information.tagRelaList.length ? (
                        <Image
                          alt="标签图标"
                          preview={false}
                          className="mr-[8px] w-[14px] h-[14px]"
                          src="//static.szlcsc.com/ecp/assets/web/page/activity/informationIndustryDetails/images/infolistbiaoqian.png"
                        />
                      ) : null}
                      {information.tagRelaList?.map((tagRela, index) => (
                        <>
                          <span
                            className="text-[#0093e6] cursor-pointer"
                            onClick={() => keyWordHref(tagRela.informationTagName)}
                          >
                            {tagRela.informationTagName}
                          </span>
                          {index < information.tagRelaList.length - 1 ? (
                            <span className="text-[#f0f0f0]">&nbsp;|&nbsp;</span>
                          ) : null}
                        </>
                      ))}
                    </div>
                    <div className="mt-[6px] mb-[6px]">
                      <span className="text-[#999]">上一篇：</span>
                      {infoDetail.upInformation ? (
                        <a
                          data-spm="syp"
                          href={`${Domains.lcscWwwUrl}/info/${infoDetail.upInformation.informationId}.html`}
                          title={infoDetail.upInformation.title}
                        >
                          {infoDetail.upInformation?.title?.slice(0, 25)}
                        </a>
                      ) : (
                        <span>没有了</span>
                      )}
                      <span className="ml-[40px] text-[#999]">下一篇：</span>
                      {infoDetail.nextInformation ? (
                        <a
                          data-spm="xyp"
                          href={`${Domains.lcscWwwUrl}/info/${infoDetail.nextInformation.informationId}.html`}
                          title={infoDetail.nextInformation.title}
                        >
                          {infoDetail.nextInformation?.title?.slice(0, 25)}
                        </a>
                      ) : (
                        <span>没有了</span>
                      )}
                    </div>
                  </div>
                </div>
                <ShareComponent />
                <div className="you-like mt-[30px] pt-[30px] border-t border-solid border-[#f0f0f0]">
                  <div className="text-[16px] font-bold text-[#0093e6]">猜你喜欢</div>
                  <ul className="mt-[20px] overflow-hidden" data-spm="gus">
                    {infoDetail?.likeList?.map((likeArticle, index) => (
                      <li
                        key={index}
                        className={index === 0 ? 'float-left w-[248px]' : 'float-left w-[248px] ml-[37px]'}
                      >
                        <a data-spm={index + 1} href={`${Domains.lcscWwwUrl}/info/${likeArticle.informationId}.html`}>
                          <Image
                            preview={false}
                            src={likeArticle.titleImage}
                            className="w-[248px] h-[137px] inline"
                            alt={likeArticle.title}
                          />
                        </a>
                        <p className="m-[5px_auto_0] w-[75%] text-center">
                          <a
                            data-spm={index + 1}
                            href={`${Domains.lcscWwwUrl}/info/${likeArticle.informationId}.html`}
                            title={likeArticle.title}
                          >
                            {likeArticle?.title?.slice(0, 50)}
                          </a>
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : (
              <div className="p-[25px_0] w-[95%] m-[0_auto] text-center text-[16px] border-b border-solid border-[#f0f0f0]">
                没有查询结果！
              </div>
            )}
          </div>
        </section>
        {/* 右边 */}
        <InfoPageRight infoList={infoDetail} searchCb={(e) => searchCb(e)} />
      </div>
    </>
  );
};
export default InfoDetail;
